import { AiOutlineMail, AiOutlinePhone } from 'react-icons/ai';
import { FaMapMarkerAlt } from 'react-icons/fa';
import { v4 as uuidv4 } from 'uuid';

const contactData = [
    {
        id: uuidv4(),
        icon: <AiOutlineMail />,
        heading: 'Adresă Email',
        text: 'Trimite-ne un email oricând',
        item1: 'office@reparatiiasfalt.ro',
        item2: '',
    },

    {
        id: uuidv4(),
        icon: <AiOutlinePhone />,
        heading: 'Număr de Telefon',
        text: 'Sună-ne oricând',
        item1: '0724.273.258',
        item2: '',
    },

    {
        id: uuidv4(),
        icon: <FaMapMarkerAlt />,
        heading: 'Adresă Birou',
        text: 'Vizitează-ne la sediu',
        item1: 'Strada Bujorilor 4',
        item2: 'Măgurele 077126, Ilfov',
    },
];

export default contactData;
